/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

/**
 * PSYCHOLOGY
 */

import { SECURE_ENDPOINT } from "@/app/core/ApiConfiguration";

export default class ServiceConstant {
  static PATIENT_MNGT_LIST_PAGED_RECEPTION = SECURE_ENDPOINT + "pnt/pnt01";
  static PATIENT_MNGT_LIST_PAGED_CLINIC_HISTORY = SECURE_ENDPOINT + "pnt/ch01";
  static PATIENT_INFOBYID = SECURE_ENDPOINT + "pnt/pnt04";
  static PATIENT_GET_PHOTO = SECURE_ENDPOINT + "pnt/pnt05";

  static PATIENT_CANCEL_APPOINTMENT = SECURE_ENDPOINT + "med/med02";

  /**PSYCHOLOGY PENDING */

  static PSYCHOLOGY_LISTALL_PAGINATION = SECURE_ENDPOINT + "psh/psh01";
  static PSYCHOLOGY_GET = SECURE_ENDPOINT + "psh/psh05";
  static PSYCHOLOGY_ADD = SECURE_ENDPOINT + "psh/psh04";
  static PSYCHOLOGY_PDF = SECURE_ENDPOINT + "rpsvc/rp32";

  /**PSYCHOLOGY HISTORIAL */

  static PSYCHOLOGY_LISTATTEND_PAGINATION = SECURE_ENDPOINT + "psh/psh02";
  static PSYCHOLOGY_GET_HISTORIAL = SECURE_ENDPOINT + "psh/psh06";
  static PSYCHOLOGY_UPDATE = SECURE_ENDPOINT + "psh/psh03";
  static PSYCHOLOGY_EXCEL = SECURE_ENDPOINT + "pshrp/pshr01";

  /*CONSULTATION INFO */

  static CONSULTATION_GET_INFO = SECURE_ENDPOINT + "med/med01";
  static STUDY_GET_INFO = SECURE_ENDPOINT + "stu/stu01";

  /**MASTOGRAPHY FINDING */
  static MASTOGRAPHYFINDING_LISTALL_PAGINATION = SECURE_ENDPOINT + "typf/typf01";
  static MASTOGRAPHYFINDING_GET = SECURE_ENDPOINT + "typf/typf06";
  static MASTOGRAPHYFINDING_ADD = SECURE_ENDPOINT + "typf/typf03";
  static MASTOGRAPHYFINDING_UPDATE = SECURE_ENDPOINT + "typf/typf04";
  static MASTOGRAPHYFINDING_DELETE = SECURE_ENDPOINT + "typf/typf05";
  static MASTOGRAPHYFINDING_LISTALL = SECURE_ENDPOINT + "typf/typf02";


  /**INTERPRETATION PENDING */
  static STUDY_BY_ID = SECURE_ENDPOINT + 'stuvc/stu11';
  static INTERPRETATIONPENDING_LISTALL_PAGINATION = SECURE_ENDPOINT + "inter/inter01"
  static INTERPRETATIONPENDING_FINDALL_IMAGESBYSTUDY = SECURE_ENDPOINT + 'stuvc/stu19';
  static INTERPRETATION_ADD = SECURE_ENDPOINT + "intervc/inter11";
  
  /**IINTERPRETATION HISTORY */
  static INTERPRETATIONHISTORY_LISTALL_PAGINATION = SECURE_ENDPOINT + "inter/inter02"
  static INTERPRETATION_UPDATE = SECURE_ENDPOINT + "intervc/inter03";
  static INTERPRETATION_REPORT_HISTORY_XLSX = `${SECURE_ENDPOINT}interp/interp01`;


  /**INTERPRETATION VALIDATE */
  static INTERPRETATION_VALIDATE_LIST_PAGINATION = SECURE_ENDPOINT + "inter/intrvl01"

  /**CAMUJAL */
  static CAMUJAL_LISTALL_PAGINATION_TOSEND = SECURE_ENDPOINT + "cmj/cmj01"
  static CAMUJAL_LISTALL_PAGINATION_SENT = SECURE_ENDPOINT + "cmj/cmj03"
  static CAMUJAL_HISTORYSEND = SECURE_ENDPOINT + "cmj/cmj02"
  static CAMUJAL_SENDSTUDY = SECURE_ENDPOINT + "cmj/cmj04"
  static CAMUJAL_SENDSTUDY_DISCARTED = SECURE_ENDPOINT + "cmj/cmj05"

  /**WEB SERVICES */
  static WEBSERVICES_LISTALL_PAGINATION = SECURE_ENDPOINT + "websrv/websrv01";
  static WEBSERVICES_GET = SECURE_ENDPOINT + "websrv/websrv05";
  static WEBSERVICES_ADD = SECURE_ENDPOINT + "websrv/websrv02";
  static WEBSERVICES_UPDATE = SECURE_ENDPOINT + "websrv/websrv03";
  static WEBSERVICES_DELETE = SECURE_ENDPOINT + "websrv/websrv04";

  
  /**Visualizador */
  static STUDY_FIND_URL_JNLP = SECURE_ENDPOINT + 'stu/stu22';
  static INTERPRETATION_VALIDATE_TO_INTERPRET = SECURE_ENDPOINT + "stu/stu03";
  static INTERPRETATION_RESET_STATUS_INTERPRETING = SECURE_ENDPOINT + "stu/stu02";
  static UNLOCKING_INTERPRETATION = `${SECURE_ENDPOINT}inter/intr17`;

    /**OPTOMETRY PENDING */

    static OPTOMETRY_LISTALL_PAGINATION = SECURE_ENDPOINT + "opt/opt01";
    static OPTOMETRY_GET = SECURE_ENDPOINT + "opt/opt02";
    static OPTOMETRY_ADD = SECURE_ENDPOINT + "opt/opt03";
  
    /**OPTOMETRY HISTORY */
  
    static OPTOMETRY_LISTALLHISTORY_PAGINATION = SECURE_ENDPOINT + "opt/opt04";
    static OPTOMETRY_GET_HISTORIAL = SECURE_ENDPOINT + "opt/opt05";
    static OPTOMETRY_UPDATE = SECURE_ENDPOINT + "opt/opt06";
    static OPTOMETRY_EXCEL = SECURE_ENDPOINT + "optrp/optrp01";


    /**OPTOMETRY PROCEDURES AND ZONE */
    static OPTOMETRY_PROCEDURES = SECURE_ENDPOINT + "tprsv/tpr01";
    static OPTOMETRY_ZONES = SECURE_ENDPOINT + "besv/be01";
    static OPTOMETRY_SIDE = SECURE_ENDPOINT + "bpsv/bp01";
    static OPTOMETRY_GLASSESTYPES = SECURE_ENDPOINT + "tglsv/tgl01";

    /**AUDIOMETRY PENDING */
    static AUDIOMETRY_LISTALL_PAGINATION = SECURE_ENDPOINT + "aud/aud01";
    static AUDIOMETRY_GET = SECURE_ENDPOINT + "aud/aud02";
    static AUDIOMETRY_ADD = SECURE_ENDPOINT + "aud/aud03";

    /**AUDIOMETRY HISTORY */
    static AUDIOMETRY_LISTALLHISTORY_PAGINATION = SECURE_ENDPOINT + "aud/aud04";
    static AUDIOMETRY_GET_HISTORY = SECURE_ENDPOINT + "aud/aud05";
    static AUDIOMETRY_UPDATE = SECURE_ENDPOINT + "aud/aud06";
    static AUDIOMETRY_EXCEL = SECURE_ENDPOINT + "audrp/audrp01";

    /**AUDIOMETRY PARTS */
    static AUDIOMETRY_PART = SECURE_ENDPOINT + "bpsv/bp02";
    static AUDIOMETRY_RANGEHEARINGLOSS = SECURE_ENDPOINT + "aud/aud07";


    /**JOB LIST */
    static LIST_JOBS = SECURE_ENDPOINT + "occup/occup01";

     /**TEMPLATE INTERPRETATION */
  static TEMPLATE_LISTALL = SECURE_ENDPOINT + "tmpli/tmpli01"
  static TEMPLATE_LISTALL_PAGINATION = SECURE_ENDPOINT + "tmpli/tmpli02";
  static TEMPLATE_GET = SECURE_ENDPOINT + "tmpli/tmpli03";
  static TEMPLATE_ADD = SECURE_ENDPOINT + "tmpli/tmpli06";
  static TEMPLATE_UPDATE = SECURE_ENDPOINT + "tmpli/tmpli04";
  static TEMPLATE_DELETE = SECURE_ENDPOINT + "tmpli/tmpli05";

  /**HISTORY STUDIES */
  static HISTORY_STUDIES_LISTALL_PAGINATION = SECURE_ENDPOINT + "stu/stu04";
  static HISTORY_STUDIES_DOWNLOAD_REPORT = SECURE_ENDPOINT + "strp/strp01";

  
  /**CONFIGURATION */
  static CONFIGURATION_FIND_ALLOW_COPY_PASTE_INTERPRETATION =  `${SECURE_ENDPOINT}conf/conf03`;
  static CONFIGURATION_FIND_OSIRIX_PATH =  `${SECURE_ENDPOINT}conf/conf04`;

  /**
   * @param Author Jesus Rafael Nava Cruz
   */

  /**
   * PRODUCT SERVICE
   */
  static PRODUCT_LIST_ALL = SECURE_ENDPOINT + "prsv/pr01";
  static PRODUCT_LIST_ALL_PAGINATION = SECURE_ENDPOINT + "prsv/pr02";
  static PRODUCT_ADD = SECURE_ENDPOINT + "prsv/pr03";
  static PRODUCT_GET = SECURE_ENDPOINT + "prsv/pr04";
  static PRODUCT_UPDATE = SECURE_ENDPOINT + "prsv/pr05";
  static PRODUCT_DELETE = SECURE_ENDPOINT + "prsv/pr06";

  /**
   * DOCTOR SERVICE
   */
  static DOCTOR_LIST_ALL = SECURE_ENDPOINT + "dct/dct01";
  static DOCTOR_LIST_ALL_PAGINATION = SECURE_ENDPOINT + "dct/dct04";
  static DOCTOR_ADD = SECURE_ENDPOINT + "dct/dct02";
  static DOCTOR_GET = SECURE_ENDPOINT + "dct/dct05";
  static DOCTOR_UPDATE = SECURE_ENDPOINT + "dct/dct06";

  /**
   * LOG SERVICE
   */
  static LOG_LIST_ALL = SECURE_ENDPOINT + 'log/log01';
  static LOG_LIST_ALL_PAGINATION = SECURE_ENDPOINT + 'log/log02';
  static LOG_ADD = SECURE_ENDPOINT + 'log/log03';
  static LOG_GET = SECURE_ENDPOINT + 'log/log04';
  static LOG_UPDATE = SECURE_ENDPOINT + 'log/log07';
  static LOG_DELETE = SECURE_ENDPOINT + 'log/log06';

  /**
   * SYNC SERVICE
   */
  static SYNC_LIST_ALL_PAGINATION = SECURE_ENDPOINT + 'sync/sync01';
  static SYNC_ADD = SECURE_ENDPOINT + 'sync/sync02';
  static SYNC_GET = SECURE_ENDPOINT + 'sync/sync03';
  static SYNC_UPDATE = SECURE_ENDPOINT + 'sync/sync04';
  static SYNC_DELETE = SECURE_ENDPOINT + 'sync/sync05';

  /**
   * PHYSICAL SPACES SERVICE
   */
  static PHYSICAL_SPACES_LIST_ALL_PAGINATION = SECURE_ENDPOINT + 'prsv/pr02';
  static PHYSICAL_SPACES_LIST_ALL = SECURE_ENDPOINT + 'prsv/pr01';
  static PHYSICAL_SPACES_ADD = SECURE_ENDPOINT + 'prsv/pr03';
  static PHYSICAL_SPACES_GET = SECURE_ENDPOINT + 'prsv/pr04';
  static PHYSICAL_SPACES_UPDATE = SECURE_ENDPOINT + 'prsv/pr05';
  static PHYSICAL_SPACES_DELETE = SECURE_ENDPOINT + 'prsv/pr06';

  /**IMAGEH HISTORY */
  static IMAGE_HISTORY_LITS_PAGINATION = `${SECURE_ENDPOINT}stu/stu07`;



    /**COLPOSCOPY PENDING */
    static COLPOSCOPY_LISTALL_PAGINATION = `${SECURE_ENDPOINT}clps/clps01`;
    static COLPOSCOPY_GET = `${SECURE_ENDPOINT}clps/clps02`;
    static COLPOSCOPY_ADD = `${SECURE_ENDPOINT}clps/clps03`;

    /**COLPOSCOPY HISTORY */
    static COLPOSCOPY_LIST_HISTORY_PAGINATION =  `${SECURE_ENDPOINT}clps/clps04`;
    static COLPOSCOPY_GET_HISTORY =  `${SECURE_ENDPOINT}clps/clps05`;
    static COLPOSCOPY_UPDATE =  `${SECURE_ENDPOINT}clps/clps06`;
    static COLPOSCOPY_EXCEL =  `${SECURE_ENDPOINT}clpsrp/clpsrp01`;

      /**TELEMEDICINE PENDING */
      static TELEMEDICINE_LISTALL_PAGINATION = `${SECURE_ENDPOINT}telmed/telmed01`;
      static TELEMEDICINE_GET = `${SECURE_ENDPOINT}telmed/telmed03`;

      /**TELEMEDICINE TO START */
      static TELEMEDICINE_LIST_TO_START_PAGINATION =  `${SECURE_ENDPOINT}telmed/telmed02`;

      /**TELEMEDICINE HISTORY */
      static TELEMEDICINE_LIST_HISTORY_PAGINATION =  `${SECURE_ENDPOINT}telmed/telmed06`;
      static TELEMEDICINE_GET_HISTORY =  `${SECURE_ENDPOINT}telmed/telmed08`;
      static TELEMEDICINE_UPDATE_DIAGNOSIS =  `${SECURE_ENDPOINT}telmed/telmed05`;
      static TELEMEDICINE_UPDATE_HISTORY =  `${SECURE_ENDPOINT}telmed/telmed07`;


      /** TELEMEDICINE SAVE DIAGNOSIS AND FILES */
      static TELEMEDICINE_SAVE_DIAGNOSIS_FILES = `${SECURE_ENDPOINT}telmed/telmed04`;

      static TELEMEDICINE_SAVE_FILES = `${SECURE_ENDPOINT}telmed/telmed07`;


  }
